import * as PATHS from './urlConstants';

export const PAGE_DEFAULT_TAB_TITLE = 'amondz admin';

export const PAGE_TAB_TITLE_LIST: Record<string, string> = {
  [PATHS.PAYMENT_PG_ROUTE_URL_PATH]: '결제 관리 - 결제 설정',
  [PATHS.PAYMENT_PG_FEE_URL_PATH]: '결제 관리 - PG 수수료 관리',
  /********** 인트로 **********/
  [PATHS.LOGIN_URL_PATH]: 'AMONDZ ADMIN - 로그인',

  /********** 홈 **********/
  [PATHS.HOME_URL_PATH]: '홈 - 대시보드',

  /********** 계정 관리 **********/
  [PATHS.ACCOUNT_USER_LIST_URL_PATH]: '계정 관리 - 유저 리스트',
  [PATHS.ACCOUNT_USER_DETAIL_URL_PATH]: '계정 관리 - 유저 상세',
  [PATHS.ACCOUNT_SELLER_LIST_URL_PATH]: '계정 관리 - 판매자 리스트',
  [PATHS.ACCOUNT_ADMIN_LIST_URL_PATH]: '계정 관리 - 관리자 리스트',

  /********** 브랜드 관리**********/
  [PATHS.BRAND_JOIN_LIST_URL_PATH]: '브랜드 관리 - 입점승인 리스트',
  [PATHS.BRAND_ALL_LIST_URL_PATH]: '브랜드 관리 - 브랜드 리스트',
  [PATHS.BRAND_DETAIL_URL_PATH]: '브랜드 관리 - 브랜드 상세',
  [PATHS.BRAND_TIER_URL_PATH]: '브랜드 관리 - 브랜드 티어 관리',
  [PATHS.BRAND_TOP_EXPOSURE_URL_PATH]: '브랜드 관리 - 브랜드 상단 노출 관리',
  [PATHS.BRAND_EXPOSURE_URL_PATH]: '브랜드 관리 - 브랜드 노출 순서 관리',

  /********** 상품 관리 **********/
  [PATHS.PRODUCT_ALL_LIST_URL_PATH]: '상품 관리 - 상품 전체 리스트',
  [PATHS.PRODUCT_APPROVAL_LIST_URL_PATH]: '상품 관리 - 상품 승인 리스트',
  [PATHS.PRODUCT_BAN_LIST_URL_PATH]: '상품 관리 - 상품 금지 리스트',
  [PATHS.PRODUCT_CREATE_URL_PATH]: '상품 관리 - 상품 등록',
  [PATHS.PRODUCT_BULK_EDIT_URL_PATH]: '상품 관리 - 상품 일괄 편집',
  [PATHS.PRODUCT_EDIT_URL_PATH]: '상품 관리 - 상품 편집',
  [PATHS.PRODUCT_DETAIL_URL_PATH]: '상품 관리 - 상품 상세',
  [PATHS.PRODUCT_VERSION_URL_PATH]: '상품 관리 - 상품 버전',

  /********** 주문 내역 **********/
  [PATHS.ORDER_ALL_LIST_URL_PATH]: '주문 내역 - 주문/배송 내역 리스트',
  [PATHS.ORDER_CANCEL_LIST_URL_PATH]: '주문 내역 - 취소 내역 리스트',
  [PATHS.ORDER_RETURN_LIST_URL_PATH]: '주문 내역 - 반품 내역 리스트',
  [PATHS.ORDER_EXCHANGE_LIST_URL_PATH]: '주문 내역 - 교환 내역 리스트',
  [PATHS.ORDER_DETAIL_URL_PATH]: '주문 내역 - 주문 상세',
  [PATHS.ORDER_RETURN_DETAIL_URL_PATH]: '주문 내역 - 주문 반품 상세',

  /********** 주문 관리 **********/
  [PATHS.ORDER_MANAGEMENT_LIST_URL_PATH]: '주문 관리 - 주문/배송관리',
  [PATHS.ORDER_CANCEL_MANAGEMENT_URL_PATH]: '주문 관리 - 취소 관리',
  [PATHS.ORDER_RETURN_MANAGEMENT_URL_PATH]: '주문 관리 - 반품 관리',
  [PATHS.ORDER_EXCHANGE_MANAGEMENT_URL_PATH]: '주문 관리 - 교환 관리',

  /********** 멀티채널 관리 **********/
  [PATHS.MULTI_CHANNEL_ORDER_MANAGEMENT_URL_PATH]: '멀티채널 관리 - 멀티채널 주문 관리',
  [PATHS.MULTI_CHANNEL_ORDER_CREATE_URL_PATH]: '멀티채널 관리 - 멀티채널 주문 생성',

  /********** 정산 관리 **********/
  [PATHS.BALANCE_WAITING_LIST_URL_PATH]: '정산 관리 - 정산 대기 리스트',
  [PATHS.BALANCE_DONE_LIST_URL_PATH]: '정산 관리 - 정산 완료 리스트',
  [PATHS.BALANCE_HOLD_LIST_URL_PATH]: '정산 관리 - 정산 보류 리스트',
  [PATHS.BALANCE_EXECUTION_URL_PATH]: '정산 관리 - 정산 수행',
  [PATHS.BALANCE_ADJUSTMENT_BASE_DATE_URL_PATH]: '정산 관리 - 정산 기준일 변경',
  [PATHS.BALANCE_ADJUSTMENT_COMPLETE_DATE_URL_PATH]: '정산 관리 - 정산 완료일 변경',

  /********** 태그 관리 **********/
  [PATHS.TAG_CREATE_URL_PATH]: '태그 관리 - 태그 등록',
  [PATHS.TAG_LIST_URL_PATH]: '태그 관리 - 태그 리스트',
  [PATHS.TAG_GROUP_CREATE_URL_PATH]: '태그 관리 - 태그 그룹 등록',
  [PATHS.TAG_GROUP_LIST_URL_PATH]: '태그 관리 - 태그 그룹 리스트',
  [PATHS.TAG_TAB_MAIN_MANAGEMENT_URL_PATH]: '태그 관리 - 태그 탭 메인 관리',
  [PATHS.TAG_TREND_KEYWORD_MANAGEMENT_URL_PATH]: '태그 관리 - 태그 트렌드 키워드 관리',

  /********** 카테고리 관리 **********/
  [PATHS.CATEGORY_CREATE_MANAGEMENT_URL_PATH]: '카테고리 관리 - 카테고리 생성 관리',
  [PATHS.CATEGORY_EXHIBIT_MANAGEMENT_URL_PATH]: '카테고리 관리 - 카테고리 전시 관리',

  /********** 원격 이미지 관리 **********/
  [PATHS.REMOTE_SPLASH_IMAGE_LIST_URL_PATH]: '원격 이미지 관리 - 스플래시 이미지 리스트',
  [PATHS.REMOTE_SPLASH_IMAGE_CREATE_URL_PATH]: '원격 이미지 관리 - 스플래시 이미지 등록',
  [PATHS.REMOTE_SPLASH_IMAGE_EDIT_URL_PATH]: '원격 이미지 관리 - 스플래시 이미지 수정',
  [PATHS.REMOTE_REFERRAL_IMAGE_LIST_URL_PATH]: '원격 이미지 관리 - 레퍼럴 이미지 리스트',
  [PATHS.REMOTE_REFERRAL_IMAGE_CREATE_URL_PATH]: '원격 이미지 관리 - 레퍼럴 이미지 등록',
  [PATHS.REMOTE_REFERRAL_IMAGE_EDIT_URL_PATH]: '원격 이미지 관리 - 레퍼럴 이미지 수정',

  /********** 프로모션 관리 **********/
  [PATHS.PROMOTION_SCHEDULE_URL_PATH]: '프로모션 관리 - 프로모션 타임라인',
  [PATHS.PROMOTION_SCHEDULE_LIST_URL_PATH]: '프로모션 관리 - 프로모션 리스트',
  /**
   * ⚠️ 상세(`/promotion/schedule/:id`)는 여기 넣어도 안 걸린다 — `PageTemplate` 이
   * `PAGE_TAB_TITLE_LIST[location.pathname]` 로 **정확히 일치**하는 키만 찾는데,
   * 실제 경로에는 id 가 박혀 있다. 그래서 상세 탭 제목은 기본값 'AMONDZ ADMIN' 으로 뜬다.
   *
   * 고치려면 `PageTemplate` 이 패턴 매칭을 하거나 `pageName` 으로 폴백해야 하는데,
   * 그건 이 상수 파일이 아니라 **공용 템플릿을 건드리는 일**이라 여기서 하지 않는다
   * (id 가 들어가는 다른 상세 화면들도 같은 상태다).
   */

  /********** 기획전 관리 **********/
  [PATHS.EVENT_IN_PROGRESS_LIST_URL_PATH]: '기획전 관리 - 홈에 노출중인 기획전 리스트',
  [PATHS.EVENT_ALL_LIST_URL_PATH]: '기획전 관리 - 기획전 전체 리스트',
  [PATHS.EVENT_CREATE_URL_PATH]: '기획전 관리 - 기획전 등록',
  [PATHS.EVENT_EDIT_URL_PATH]: '기획전 관리 - 기획전 편집',

  /********** 쿠폰 관리 **********/
  [PATHS.COUPON_LIST_URL_PATH]: '쿠폰 관리 - 쿠폰 리스트',
  [PATHS.COUPON_GENERATE_URL_PATH]: '쿠폰 관리 - 쿠폰 발급',
  [PATHS.COUPON_EDIT_URL_PATH]: '쿠폰 관리 - 쿠폰 편집',
  [PATHS.COUPON_DETAIL_URL_PATH]: '쿠폰 관리 - 쿠폰 상세',
  [PATHS.COUPON_CREATE_URL_PATH]: '쿠폰 관리 - 쿠폰 등록',

  /********** 페이지 관리 **********/
  [PATHS.MAIN_PAGE_MANAGEMENT_URL_PATH]: '페이지 관리 - 메인 페이지 관리',
  [PATHS.SUB_PAGE_LIST_URL_PATH]: '페이지 관리 - 서브 페이지 리스트',
  [PATHS.SUB_PAGE_CREATE_URL_PATH]: '페이지 관리 - 서브 페이지 등록',
  [PATHS.SUB_PAGE_MANAGEMENT_URL_PATH]: '페이지 관리 - 서브 페이지 관리',
  [PATHS.SUB_PAGE_EDIT_URL_PATH]: '페이지 관리 - 서브 페이지 편집',
  [PATHS.WIDGET_ALL_LIST_URL_PATH]: '페이지 관리 - 위젯 전체 리스트',
  [PATHS.WIDGET_CREATE_URL_PATH]: '페이지 관리 - 위젯 생성',
  [PATHS.WIDGET_EDIT_URL_PATH]: '페이지 관리 - 위젯 편집',
  [PATHS.WIDGET_COPY_URL_PATH]: '페이지 관리 - 위젯 복사',
  [PATHS.WIDGET_HOME_MENU_CREATE_URL_PATH]: '페이지 관리 - 메뉴 등록 및 편집',
  [PATHS.MAIN_TAB_MANAGEMENT_URL_PATH]: '페이지 관리 - 홈 탭 등록 및 편집',

  /********** 공지사항 관리**********/
  [PATHS.NOTICE_STORE_LIST_URL_PATH]: '공지사항 관리 - 상점 공지사항 리스트',
  [PATHS.NOTICE_STORE_CREATE_URL_PATH]: '공지사항 관리 - 상점 공지사항 등록',
  [PATHS.NOTICE_STORE_EDIT_URL_PATH]: '공지사항 관리 - 상점 공지사항 편집',
  [PATHS.NOTICE_PRODUCT_LIST_URL_PATH]: '공지사항 관리 - 상품 공지사항 리스트',
  [PATHS.NOTICE_PRODUCT_DETAIL_URL_PATH]: '공지사항 관리 - 상품 공지사항 상세',

  /********** 검색 키워드 관리**********/
  [PATHS.SEARCH_WORD_LIST_URL_PATH]: '검색 키워드 관리 - 검색 키워드 리스트',
  [PATHS.SEARCH_WORD_CREATE_URL_PATH]: '검색 키워드 관리 - 검색 키워드 등록',
  [PATHS.SEARCH_DICTIONARY_URL_PATH]: '검색 관리 - 검색 사전',
  [PATHS.SEARCH_DICTIONARY_SYNONYM_CREATE_URL_PATH]: '검색 관리 - 동의어 규칙 등록',

  /********** 문의 관리**********/
  [PATHS.CS_INQUIRY_LIST_URL_PATH]: '문의 관리 - 1:1 문의 리스트',
  [PATHS.CS_INQUIRY_DETAIL_URL_PATH]: '문의 관리 - 1:1 문의 상세',
  [PATHS.CS_QNA_LIST_URL_PATH]: '문의 관리 - 상품 문의 리스트',
  [PATHS.CS_QNA_DETAIL_URL_PATH]: '문의 관리 - 상품 문의 상세',

  /********** 후기 관리**********/
  [PATHS.CS_REVIEW_LIST_URL_PATH]: '후기 관리 - 상품 후기 리스트',
  [PATHS.CS_REVIEW_CREATE_URL_PATH]: '후기 관리 - 상품 후기 등록',
  [PATHS.CS_REVIEW_DETAIL_URL_PATH]: '후기 관리 - 상품 후기 상세',

  /********** 추천 관리 **********/
  [PATHS.RECOMMEND_PRODUCT_LIST_URL_PATH]: '추천관리 - 상품 추천 리스트',
  [PATHS.RECOMMEND_PRODUCT_DETAIL_URL_PATH]: '추천관리 - 상품 추천 상세',
  [PATHS.RECOMMEND_PRODUCT_COPY_URL_PATH]: '추천관리 - 상품 추천 복제',

  /********** 버전 관리 **********/
  [PATHS.VERSION_LIST_URL_PATH]: '버전관리 - 버전 리스트',
  [PATHS.VERSION_CREATE_URL_PATH]: '버전관리 - 버전 등록',
  [PATHS.VERSION_EDIT_URL_PATH]: '버전관리 - 버전 편집',

  /********** 포인트 관리 **********/
  [PATHS.POINT_LIST_URL_PATH]: '포인트관리 - 포인트 내역 리스트',
  [PATHS.POINT_GENERATE_URL_PATH]: '포인트관리 - 포인트 발급',
  [PATHS.POINT_RANKING_LIST_URL_PATH]: '포인트관리 - 포인트 랭킹',

  /********** 아몬즈 서비스**********/
  [PATHS.SERVICE_LIST]: '아몬즈 서비스 리스트',
};

export const PAGE_ERROR_MESSAGE = {
  USER_ACCESS_DENIED_MESSAGE: '권한이 없는 유저입니다.',
  PLAIN_ERROR_MESSAGE: '에러가 발생했습니다',
  PAGE_NOT_FOUND_MESSAGE: '요청하신 페이지를 찾을 수 없어요.',
  UNABLE_TO_PROCESS_MESSAGE: '요청한 응답을 처리할 수 없어요',
  INVALID_URL_INPUT_MESSAGE: '입력하신 주소가 정확한지 다시 한번 확인해주세요.',
};

export const ERROR_PAGE_BUTTON_MESSAGE = {
  REDIRECT_LOGIN: '로그인 페이지로 이동',
  REDIRECT_PREVIOUS_PAGE: '이전 페이지로 이동',
};
